// extracted by mini-css-extract-plugin
export var fadeIn = "_8t-0";